const axios = require('axios');
var SessionStorageManager = require('./SessionStorageManager');

function ApiClient(options){
    var self = this;

    self.token = null;

    self.retries = 0;
    self.max_retries = 5;
    self.base_url =  (options != null && options.base_url != null) ? options.base_url: '';

    self.storage = new SessionStorageManager();


    self.setToken = function(t){
        self.token = t;
        self.storage.set('t',t);
    };

    self.setBaseUrl = function(url){
        self.base_url = url;
    };

    if(options.token != null)
        self.token = options.token;

    self.getToken = function(){
        var token = self.token;
        if(token == null)
            token = self.storage.get('t');
        return token;
    }



    self.call = function(url,data,successCallback,errorCallback,type,loader,headers){

        type = (type == null) ? 'get' : type.toLowerCase();
        if(loader != null && typeof loader.show == 'function')
            loader.show();

        var config = {
            method: type,
            url: url,
            headers: {
				'X-Requested-With': 'XMLHttpRequest',
                'x-token': self.getToken(),
				'X-CSRF-TOKEN': self.getToken()
            },
            maxRedirects: 0,
            timeout: 180000
        };
        if(options.timeout)
            config.timeout = options.timeout*1000;  //To convert from seconds to milliseconds

        if(headers != null){
            for(var j in headers)
                config.headers[j] = headers[j];
        }

        if(type=='get')
            config.params = data;
        else
            config.data = data;

        const request = axios(config)
            .then(function(response){
                if(typeof successCallback == 'function');
                    successCallback(response.data);
            }).catch(function(error){
                console.log(typeof error.response != 'undefined' ? error.response : error);
                var do_log = true;

				if (typeof errorCallback == 'function')
					errorCallback(typeof error.response != 'undefined' ? error.response : error);

            });

        return request;
    };

}

module.exports = ApiClient;
